export default function ({ $auth, redirect }) {
  const user = $auth.user
  if (!user.email.includes('@qontak.com')) {
    // return redirect('/whatsapp/contacts')
  }
}
